import pinkbanner from "../images/reccartbanner.png";
import Adresspopup from "./Adresspopup";
import { ChevronLeft, ChevronRight } from "lucide-react";
import featuredImage from "../images/Featured.png";
import { Link } from "react-router-dom";
import axios from "axios";
import logo from "../images/logo.png";
import { DivideSquare, MapPin } from "lucide-react";
import editIcon from "../images/editicon.svg";
import carticon from "../images/cart_icon.png";
import { useNavigate } from "react-router-dom";
import { DeleteIcon } from "lucide-react";
import React, { useEffect, useRef, useState } from "react";
import { useCart } from "../Context/Createcontext";
import { toast } from "react-toastify";
import DeletePrompt from "../Components/common/DeletePrompt";
import { Helmet } from "react-helmet";
import { api_url } from "../config/config";
import cart from "../images/cart.svg";
import addToCartIcon from "../Icons/addToCartIcon.svg";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import wish from "../images/wish.svg";
import wishlist from "../images/wishlist_nofill.svg";
import { useWishlist } from "../Context/WishlistContext";
import DeletePromptForCart from "../Components/common/DeletePromptForCart";
import loader from "../images/loaderimg.png";
const loadScript = (src) => {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = src;
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};

const Cartpage = ({ onClose }) => {
  const navigate = useNavigate();
  const [showDetails, setShowDetails] = useState(false);
  const [openBranchId, setOpenBranchId] = useState(null);
  const [hasFetchedBranches, setHasFetchedBranches] = useState(false);
  const [hasFetchedAddresses, setHasFetchedAddresses] = useState(false);
  const [isCODConfirmPopUp,setIsCODConfirmPopUp] = useState(false)
const [branchError, setBranchError] = useState(false);
  const [refresh, setRefresh] = useState(0);
  const [branches, setBranches] = useState([]);
  const [selectedBranchId, setSelectedBranchId] = useState(null);
  const [quantities, setQuantities] = useState([]);
  const [selectedDeliveryOption, setSelectedDeliveryOption] = useState("home");
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isCODProcessing, setIsCODProcessing] = useState(false);
const [addressError, setAddressError] = useState(false);
  const scrollRef = useRef(null);
  const [tooltipOpen, setTooltipOpen] = useState(null);
  const [expandedAddresses, setExpandedAddresses] = useState({});
  const [deleteData, setDeleteData] = useState(null);
  const toggleAddressExpand = (id) =>
    setExpandedAddresses((prev) => ({ ...prev, [id]: !prev[id] }));
  const PREVIEW_MAX = 24;
  const getPreview = (text, max = PREVIEW_MAX) =>
    text && text.length > max ? text.slice(0, max) + "..." : text || "";
  const getRemaining = (text, max = PREVIEW_MAX) =>
    text && text.length > max ? text.slice(max) : "";
  const [originalTotal, setOriginalTotal] = useState(0);
  const [totalSaved, setTotalSaved] = useState(0);
  const {
    wishlist: wishlistItems,
    addToWishlist,
    removeFromWishlist,
    loading: wishlistLoading,
  } = useWishlist();
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showConfirm,setShowConfirm] = useState(false)
  const [paymentMode, setPaymentMode] = useState("ONLINE");
  const user = JSON.parse(localStorage.getItem("user"));
  const razorpayKey = process.env.REACT_APP_RAZORPAY_KEY;
  const {
    handleAddToCart,
    existingWishlistItem,
    showLoginPopup,
    setShowLoginPopup,
    handleRemoveFromCart,
    setCartCount,
    setCartItems
  } = useCart();
  const handleToggleView = (branchId) => {
    setOpenBranchId((prev) => (prev === branchId ? null : branchId));
  };
  const [itemsInCartInCart, setCartItemsInCart] = useState([]);
  const handleDeleteClick = (productId, variantId,data) => {
    setSelectedProduct({ productId, variantId });
    setDeleteData(data);
    setShowModal(true);
  };

  const confirmDelete = async () => {
    if (selectedProduct) {
      try {
        // Call context API to remove from server and update global count
        await handleRemoveFromCart(
          selectedProduct.productId,
          selectedProduct.variantId
        );
      } catch (e) {
        // Context handles toasts; proceed with optimistic UI update
      } finally {
        setCartItemsInCart((prev) =>
          prev.filter(
            (item) =>
              !(
                item.product_id === selectedProduct.productId &&
                item.variant_id === selectedProduct.variantId
              )
          )
        );
        setCartItems((prev) =>
          prev.filter(
            (item) =>
              !(
                item.product_id === selectedProduct.productId &&
                item.variant_id === selectedProduct.variantId
              )
          )
        );
        setSelectedProduct(null);
        setShowModal(false);
      }
    } else {
      setShowModal(false);
    }
  };
  useEffect(() => {
    // fetchCartProducts();
    // fetchCartProducts();
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    try {
      const concernRaw = localStorage.getItem("concern_id");
      const categoryRaw = localStorage.getItem("category_id");

      // ✅ Handle Single String (Convert to Array)
      let concernData = [];
      let categoryData = [];

      if (concernRaw) {
        concernData = concernRaw.startsWith("[")
          ? JSON.parse(concernRaw)
          : [concernRaw];
      }

      if (categoryRaw) {
        categoryData = categoryRaw.startsWith("[")
          ? JSON.parse(categoryRaw)
          : [categoryRaw];
      }

      setStoredConcernId(concernData);
      setCatid(categoryData);
    } catch (error) {
      console.error("Invalid JSON in localStorage, resetting values...");
      // localStorage.setItem("concern_id", JSON.stringify([]));
      // localStorage.setItem("category_id", JSON.stringify([]));
    }
  }, []);

  const indianStates = [
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
    "Andaman and Nicobar Islands",
    "Chandigarh",
    "Dadra and Nagar Haveli and Daman and Diu",
    "Delhi",
    "Jammu and Kashmir",
    "Ladakh",
    "Lakshadweep",
    "Puducherry",
  ];

  useEffect(() => {
    const updatedQuantities = itemsInCartInCart.reduce((acc, item) => {
      acc[item.variant_id] = item.quantity;
      return acc;
    }, {});
    setQuantities(updatedQuantities);
  }, [itemsInCartInCart]);

  const handleIncreaseForTrendingProduct = async (event, variant, item) => {
    event.preventDefault();
    try {
      if (!variant || !variant.variant_id) {
        console.error("❌ Invalid variant data in handleIncrease");
        return;
      }
      const quantity = await getCartQuantity(variant.variant_id);

      const cartResponse = await fetch(`${api_url}/cart`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
        body: JSON.stringify({
          product_id: variant.product_id,
          quantity: quantity + 1,
          variant_id: variant.variant_id,
        }),
      });

      const responseData = await cartResponse.json();

      if (
        !cartResponse.ok ||
        responseData.message?.toLowerCase().includes("stock not available")
      ) {
        toast.error(`${item.name} is out of stock`);
        return;
      }
      const newCart = itemsInCartInCart.map((item) =>
        item.variant_id === variant.variant_id
          ? { ...item, quantity: item.quantity + 1 }
          : item
      );
      setCartItemsInCart(newCart);
      setCartItems(newCart);
    } catch (err) {
      console.log(err);
      toast.error(`Something went wrong`);
    }
  };

  const handleDecreaseForTrendingProduct = async (event, variant) => {
    event.preventDefault();
    try {
      if (!variant || !variant.variant_id) {
        return;
      }
      const quantity = await getCartQuantity(variant.variant_id);
      if (quantity === 1) {
        handleRemoveFromCart(variant.product_id, variant.variant_id);

        return;
      }
      const cartResponse = await fetch(`${api_url}/cart`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
        body: JSON.stringify({
          product_id: variant.product_id,
          quantity: quantity - 1, 
          variant_id: variant.variant_id,
        }),
      });

      const responseData = await cartResponse.json();

      if (
        !cartResponse.ok ||
        responseData.message?.toLowerCase().includes("stock not available")
      ) {
        toast.error(`Something went wrong`);
        return;
      }
      const newCart = itemsInCartInCart.map((item) =>
        item.variant_id === variant.variant_id
          ? { ...item, quantity: item.quantity - 1 }
          : item
      );
      setCartItemsInCart(newCart);
      setCartItems(newCart);
    } catch (err) {
      console.log(err);
      toast.error(`Something went wrong`);
    }
  };

  const getCartQuantity = (variantId) => {
    const item = itemsInCartInCart.find((ci) => ci.variant_id === variantId);
    return item ? item.quantity : 0;
  };

  const handleIncrease = async (event, item) => {
    event.preventDefault();

    try {
      await handleQuantityChange(
        item.product_id,
        item.variant_id,
        item.quantity,
        item.name,
        "increase"
      );
    } catch (error) {
      console.error("Error increasing quantity:", error);
    }
  };

  const handleDecrease = async (event, item) => {
    event.preventDefault();

    if (item.quantity > 1) {
      try {
        await handleQuantityChange(
          item.product_id,
          item.variant_id,
          item.quantity,
          item.name,
          "decrease"
        );
      } catch (error) {
        console.error("Error decreasing quantity:", error);
      }
    }
  };

  const [isEditPopupOpen, setIsEditPopupOpen] = useState(false);
  const [storedConcernId, setStoredConcernId] = useState([]);
  const [catid, setCatid] = useState([]);
  const [deliveryOption, setDeliveryOption] = useState("home");
  const [error, setError] = useState(null);
  const [isEditable, setIsEditable] = useState(false);
  const [addresses, setAddresses] = useState([]);
  const [selectedAddressId, setSelectedAddressId] = useState(null);
  const [selectedAddress, setSelectedAddress] = useState(null);
  // Validation state for Edit Address popup
  const [addressErrors, setAddressErrors] = useState({
    address_title: "",
    address_line_1: "",
    address_line_2: "",
    pincode: "",
    state: "",
    mobile_number: "",
  });
  
  // Validation regex patterns
  const nameRegex = /^[A-Za-z\s]+$/;
  const addressLineRegex = /^[A-Za-z0-9\s,./\-#]+$/;
  const pincodeRegex = /^\d{6}$/;
  const mobileRegex = /^\d{10}$/;
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [currentFeatured, setCurrentFeatured] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [subtotal, setSubtotal] = useState(0);
  const [shipping, setShipping] = useState("free"); // You can modify this based on API or conditions
  const [total, setTotal] = useState(0);
  const totalFeatured = featuredProducts.length;
  const itemsPerPage = 5;
  const startFeatured = currentIndex * 5; // Start index based on 5 items

  // For desktop carousel, keep slicing; for mobile, show all
  const isMobile = typeof window !== "undefined" && window.innerWidth < 1024;
  const visibleFeatured = isMobile
    ? featuredProducts
    : featuredProducts.slice(startFeatured, startFeatured + 5);

  const totalPages = Math.ceil(featuredProducts.length / itemsPerPage); // Total pages

  // commented needs to cross check
  // useEffect(() => {
  //   setCurrentFeatured(visibleFeatured); // Shows all featured items on mobile, 5 on desktop
  // }, [currentIndex, featuredProducts, visibleFeatured]);

  const itemsPerRow = 5;

  useEffect(() => {
    const start = currentIndex * itemsPerRow;
    const end = start + itemsPerRow;
    setCurrentFeatured(featuredProducts.slice(start, end));
  }, [currentIndex, featuredProducts]);

  useEffect(() => {}, [currentIndex]);

  const handleEditClick = (address) => {
      const addressWithDefaultBool = {
      ...address,
      is_default: address.is_default === true || address.is_default === 'true'
    };
     setSelectedAddress(addressWithDefaultBool);
    setIsEditPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsEditPopupOpen(false);
    setSelectedAddress(null);
  };

  // Effect to update visible featured products
  useEffect(() => {
    const start = currentIndex * itemsPerPage;
    const end = start + itemsPerPage;
    setCurrentFeatured(featuredProducts.slice(start, end));
  }, [currentIndex, featuredProducts]);

  // Next and Previous Buttons
  const nextFeatured = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % totalPages);
  };

  const prevFeatured = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? totalPages - 1 : prevIndex - 1
    );
  };

  const [containerWidth, setContainerWidth] = useState(
    `${featuredProducts.length * 20}%`
  );

  useEffect(() => {
    const updateWidth = () => {
      if (window.innerWidth === 1024) {
        setContainerWidth(`${featuredProducts.length * 8}%`);
      } else {
        setContainerWidth(`${featuredProducts.length * 20}%`);
      }
    };

    updateWidth();

    window.addEventListener("resize", updateWidth);

    return () => window.removeEventListener("resize", updateWidth);
  }, [featuredProducts]);

  const [isPopupOpen, setPopupOpen] = useState(false);

  const togglePopup = () => {
    setPopupOpen(!isPopupOpen);
  };

  const productId = localStorage.getItem("product_id");

  useEffect(() => {
    if (!productId) {
      setError("Product ID is missing.");
      return; // Don't proceed if productId is missing
    }
  }, [productId]);

  const fetchFeaturedProduct = async () => {
    try {
      if (!localStorage.getItem("authToken")) {
        return;
      }

      const response = await fetch(`${api_url}/cart-list-products`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          "x-auth": "false",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch featured products");
      }

      const data = await response.json(); // Parse the response body to JSON

      setFeaturedProducts(data.data || []);
    } catch (error) {
      console.error("Error fetching featured products:", error);
    }
  };

  useEffect(() => {
    fetchFeaturedProduct();
  }, []);

  const [pincodeError, setPincodeError] = useState("");
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    let sanitized = value;

    if (name === "address_title") {
      sanitized = value.replace(/[^A-Za-z\s]/g, "");
    } else if (name === "address_line_1" || name === "address_line_2") {
      sanitized = value.replace(/[^A-Za-z0-9\s,./\-#]/g, "");
    } else if (name === "pincode") {
      sanitized = value.replace(/\D/g, "").slice(0, 6);
    } else if (name === "mobile_number") {
      sanitized = value.replace(/\D/g, "").slice(0, 10);
    }

    setSelectedAddress((prev) => {
      const updated = {
        ...(prev || {}),
        [name]: sanitized,
      };

      const errors = {
        address_title:
          !updated.address_title || updated.address_title.trim() === ""
            ? "This field is mandatory"
            : !nameRegex.test(updated.address_title.trim())
            ? "Only letters and spaces are allowed"
            : "",
        address_line_1:
          !updated.address_line_1 || updated.address_line_1.trim() === ""
            ? "This field is mandatory"
            : !addressLineRegex.test(updated.address_line_1.trim())
            ? "Invalid characters"
            : "",
        address_line_2:
          updated.address_line_2 && updated.address_line_2.trim() !== "" &&
          !addressLineRegex.test(updated.address_line_2.trim())
            ? "Invalid characters"
            : "",
        pincode:
          !updated.pincode || !pincodeRegex.test(updated.pincode.toString())
            ? "Enter a valid 6-digit pincode"
            : "",
        state:
          !updated.state || updated.state === ""
            ? "This field is mandatory"
            : "",
        mobile_number:
          !updated.mobile_number || !mobileRegex.test(updated.mobile_number.toString())
            ? "Enter a valid 10-digit mobile number"
            : "",
      };

      setAddressErrors(errors);
      return updated;
    });
  };

  // Derived form validity flag
  const isEditFormValid = React.useMemo(() => {
    if (!selectedAddress) return false;
    const title = selectedAddress.address_title?.trim() || "";
    const line1 = selectedAddress.address_line_1?.trim() || "";
    const line2 = selectedAddress.address_line_2?.trim() || "";
    const pin = (selectedAddress.pincode || "").toString();
    const mobile = (selectedAddress.mobile_number || "").toString();
    const stateVal = selectedAddress.state || "";

    const isNameValid = nameRegex.test(title);
    const isAddr1Valid = line1.length > 0 && addressLineRegex.test(line1);
    const isAddr2Valid = line2 === "" || addressLineRegex.test(line2);
    const isPincodeValid = pincodeRegex.test(pin);
    const isMobileValid = mobileRegex.test(mobile);
    const isStateValid = stateVal !== "";

    return (
      isNameValid &&
      isAddr1Valid &&
      isAddr2Valid &&
      isPincodeValid &&
      isMobileValid &&
      isStateValid
    );
  }, [selectedAddress]);
  const updateAddress = async (
    addressId,
    selectedAddress,
    setAddresses,
    setIsEditPopupOpen
  ) => {
    if (!addressId) {
      console.error("Address ID is missing, update request failed.");
      return;
    }

    try {
      const response = await axios.patch(
        `${api_url}/address/${addressId}`,
        {
          address_title: selectedAddress.address_title,
          address_line_1: selectedAddress.address_line_1,
          address_line_2: selectedAddress.address_line_2,
          pincode: selectedAddress.pincode,
          city: selectedAddress.city,
          state: selectedAddress.state,
          mobile_number: selectedAddress.mobile_number,
          is_default: selectedAddress.is_default,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );


      await fetchAddresses();

      toast.success("Address updated successfully!");

      setIsEditPopupOpen(false); 
    } catch (error) {
      console.error("Error updating address:", error);
      toast.error("Failed to update address. Please try again."); // ❌ Error message
    }
  };

  const handleUpdateAddress = () => {
    if (!selectedAddress) return;

    const title = selectedAddress.address_title?.trim() || "";
    const line1 = selectedAddress.address_line_1?.trim() || "";
    const line2 = selectedAddress.address_line_2?.trim() || "";
    const pin = (selectedAddress.pincode || "").toString();
    const mobile = (selectedAddress.mobile_number || "").toString();
    const stateVal = selectedAddress.state || "";

    const errors = {
      address_title:
        !title ? "This field is mandatory" : !nameRegex.test(title) ? "Only letters and spaces are allowed" : "",
      address_line_1:
        !line1 ? "This field is mandatory" : !addressLineRegex.test(line1) ? "Invalid characters" : "",
      address_line_2: line2 && !addressLineRegex.test(line2) ? "Invalid characters" : "",
      pincode: !pincodeRegex.test(pin) ? "Enter a valid 6-digit pincode" : "",
      state: !stateVal ? "This field is mandatory" : "",
      mobile_number: !mobileRegex.test(mobile) ? "Enter a valid 10-digit mobile number" : "",
    };

    setAddressErrors(errors);
    const hasErrors = Object.values(errors).some((msg) => msg);
    if (hasErrors) {
      toast.error("Please correct the highlighted fields");
      return;
    }

    updateAddress(
      selectedAddress.address_id,
      selectedAddress,
      setAddresses,
      setIsEditPopupOpen
    );
  };

  // fetching adress

  const fetchAddresses = async () => {
    try {
      if (!localStorage.getItem("authToken")) {
        return;
      }

      const response = await axios.get(`${api_url}/address/users`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      });

      if (response.data.data.length > 0) {

        const addressesWithDefaultBool = response.data.data.map(address => ({
          ...address,
          is_default: address.is_default === true || address.is_default === 'true'
        }));
        setAddresses(addressesWithDefaultBool);


        const defaultAddress = addressesWithDefaultBool.find(a => a.is_default === true) || addressesWithDefaultBool[0];
        setSelectedAddressId(defaultAddress.address_id);

        setSelectedAddress(defaultAddress);
      } else {
        setAddresses([]);
        setSelectedAddress(null);
      }
    } catch (error) {
      console.error("Error fetching addresses:", error);
    }
  };

  // Fetch the cart data
  const fetchCart = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${api_url}/cart`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      });

      const data = await response.json();

      if (response.ok) {
        const formattedProducts = data.data.cartproduct.map((item) => {
          const basePrice = Number(item.variant?.price) || 0;
          const discounted = Number(item.variant?.discounted_price) || basePrice;
          const qty = Number(item.quantity);
          return {
            product_id: item.product_id,
            variant_id: item.variant_id,
            quantity: qty,

            manufacturer: item.product?.Manufacturer?.name ?? "N/A",
            name: item.product?.name ?? "Unnamed Product",
            image:
              item.product?.product_images?.image_url?.primary_image ??
              `${api_url}/default-image.jpg`,

            price: basePrice,
            discounted_price: discounted,
            discount_price: Math.max(basePrice - discounted, 0),
            pack_size: item.variant?.pack_size ?? "-",
            discount_percent: item.product?.discount_percent ?? 0,
          };
        });
        
        setCartItemsInCart(formattedProducts);
        setCartCount(formattedProducts.length);
        await calculateSummary(formattedProducts);
      } else {
        setError(data.message || "Failed to fetch cart.");
      }
    } catch (err) {
      setError(err.message || "An unexpected error occurred.");
    } finally {
      setLoading(false);
    }
  };

  const [bill, setBill] = useState({ discount: 0, delivery_fees: 0 });

  useEffect(() => {
    if (itemsInCartInCart.length > 0) {
      let subtotal = 0;
      let discount = 0;
      let discountedTotal = 0;

      itemsInCartInCart.forEach((item) => {
        const itemTotal = item.price * item.quantity;
        const itemDiscountedTotal = item.discounted_price * item.quantity; 

        subtotal += itemTotal;
        discount += (item.price - item.discounted_price) * item.quantity;
        discountedTotal += itemDiscountedTotal; 
      });

      const delivery_fees = 0;

      setBill({
        discount: discount,
        delivery_fees: delivery_fees,
        total: discountedTotal + delivery_fees,
      });
    }
  }, [itemsInCartInCart]); 

  const handleDeleteAddress = async (addressId) => {
    try {
      const response = await fetch(`${api_url}/address/${addressId}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      });

      if (response.ok) {
        // Remove deleted address from the state
        setAddresses((prevAddresses) =>
          prevAddresses.filter((addr) => addr.address_id !== addressId)
        );
        toast.success("Address deleted successfully");
      } else {
        console.error("Failed to delete address");
      }
    } catch (error) {
      console.error("Error deleting address:", error);
    }
  };


const calculateSummary = (items) => {
  let subtotal = 0;           
  let originalTotal = 0;      
  let totalSaved = 0;          
  items.forEach((item) => {
    const itemOriginalTotal = item.price * item.quantity; 
    const itemDiscountedTotal = item.discounted_price * item.quantity; 
    const itemSaved = itemOriginalTotal - itemDiscountedTotal; 

    originalTotal += itemOriginalTotal;
    subtotal += itemDiscountedTotal;
    totalSaved += itemSaved;
  });

  const total = subtotal;

  setOriginalTotal(originalTotal);
  setSubtotal(subtotal);
  setTotal(total);
  setTotalSaved(totalSaved);
};

  useEffect(() => {
    calculateSummary(itemsInCartInCart);
  }, [itemsInCartInCart]); 

  useEffect(() => {
    fetchCart();
  }, []);

  const handleclickforfeaturedproduct = (product_id, product) => {


    navigate(`/products/${product.name?.toLowerCase().replace(/\s+/g, "-")}`, {
      state: { product_id },
    });
  };

  // ✅ Define Variables Directly in CartPage

  const handleQuantityChange = async (
    productId,
    variant_id,
    quantity,
    productName,
    operation
  ) => {
    console.log("🔹 handleQuantityChange Called with:", {
      productId,
      variant_id,
      quantity,
    });

    if (!productId || !variant_id || typeof quantity !== "number") {
      console.error("❌ Missing or invalid required fields:", {
        productId,
        variant_id,
        quantity,
      });
      return;
    }

    try {
      let newQuantity = operation === "increase" ? quantity + 1 : quantity - 1;

      const cartResponse = await fetch(`${api_url}/cart`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
        body: JSON.stringify({
          product_id: productId,
          quantity: newQuantity,
          variant_id,
        }),
      });

      const responseData = await cartResponse.json();

      if (!cartResponse.ok) {
        console.error("❌ Failed to update cart:", responseData.message);
        if (
          responseData.message?.toLowerCase().includes("stock not available")
        ) {
          toast.error(`${productName} is out of stock`);
        }
        return;
      }

      if (responseData.data) {

        setCartItemsInCart((prevCart) =>
          prevCart.map((item) =>
            item.product_id === productId && item.variant_id === variant_id
              ? { ...item, quantity: newQuantity }
              : item
          )
        );
        setCartItems((prevCart) =>
          prevCart.map((item) =>
            item.product_id === productId && item.variant_id === variant_id
              ? { ...item, quantity: newQuantity }
              : item
          )
        );
        calculateSummary(responseData.data);
      } else {
    
        fetchCart();
      }
    } catch (error) {
      console.error("❌ Error updating cart quantity:", error);
    }
  };

  const getOutOfStockProductName = (errorMessage) => {
    const match = errorMessage.match(/Product (.*?) is out of stock/);
    if (!match) return null;

    const productId = match[1]; // Extracted product id
    const product = itemsInCartInCart.find((p) => p.id === productId);
    return product ? product.name : null;
  };

  const onPayment = async () => {
    setIsProcessing(true);

    if(paymentMode === "COD"){
      // Stop the main button spinner; we'll show spinner on the Confirm button instead
      setIsProcessing(false);
      setIsCODConfirmPopUp(true)
      return
    }
    const isScriptLoaded = await loadScript(
      "https://checkout.razorpay.com/v1/checkout.js"
    );
    if (!isScriptLoaded) {
      console.error("Razorpay script failed to load.");
      setIsProcessing(false);
      return;
    }
    try {
      let userData;
      try {
        const response = await axios.get(`${api_url}/user`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        });
        userData = response.data.data;
      } catch (error) {
        console.error("Error fetching user data:", error);
        return;
      }
      // ✅ Validate name
      if (!userData || !userData.name || userData.name.trim() === "") {
        toast.error(
          "Please complete your profile (name is required) before making a payment."
        );
        setTimeout(() => {
          navigate("/profilepage");
        }, 1500);
        return;
      }

      if (itemsInCartInCart.length === 0) {
        toast.error(
          "Cart is empty. Please add products before proceeding to payment."
        );
        return;
      }

      if (selectedDeliveryOption === "home" && !selectedAddressId) {
        toast.error("Please select a delivery address before proceeding.");
        setIsProcessing(false);
        setAddressError(true);
        setTimeout(() => setAddressError(false), 2000); 
        return;
      }

      if (selectedDeliveryOption === "pickup" && !selectedBranchId) {
        toast.error("Please select a branch location before proceeding.");
        setIsProcessing(false);
        setBranchError(true);
        setTimeout(() => setBranchError(false), 2000); 
        return;
      }

      //  const isCOD = paymentMode === "COD";

      const options = {
        products: itemsInCartInCart,
        amount: itemsInCartInCart.reduce(
          (acc, item) => acc + item.discounted_price * item.quantity,
          0
        ),
        bill,
        address_id:
          selectedDeliveryOption === "home" ? selectedAddressId : null,
        branch_id:
          selectedDeliveryOption === "pickup" ? selectedBranchId : null,
        payment_status: "PENDING",
        delivery_type:
          selectedDeliveryOption === "home" ? "Home_Pickup" : "Store_Pickup",
      };

      console.log("Sending order data:", options);

      const res = await fetch(`${api_url}/api/create-order`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
        body: JSON.stringify(options),
      });

      const orderData = await res.json();
    

      const order_id = orderData?.razorpayOrder?.id;

      if (!res.ok || !order_id) {
        const productName = getOutOfStockProductName(orderData?.message);
        if (productName) {
          toast.error(`${productName} is out of stock.`);
        } else {
          toast.error(orderData?.message || "Server Error, Please try again later");
        }
        setIsProcessing(false);
        return;
      }

      // if (isCOD) {
      //   toast.success("Order placed successfully with COD!");
      //   setCartItemsInCart([]);
      //   setCartItems([]);
      //   setCartCount([]);
      //   navigate("/ThankYou");
      //   setIsProcessing(false);
      //   return;
      // }

      const paymentObject = new window.Razorpay({
        key: razorpayKey,
        order_id: order_id,
        ...orderData,
        handler: async function (response) {
        console.log("Payment Response:", response);

        setCartItemsInCart([]);
        setCartItems([]);
        setCartCount([]);
        navigate("/ThankYou");


          try {
            const verifyRes = await fetch(`${api_url}/api/verify-order`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("authToken")}`,
              },
              body: JSON.stringify({
                order_id: response.razorpay_order_id,
                payment_id: response.razorpay_payment_id,
                signature: response.razorpay_signature,
                orderId: orderData?.data?.order_id || order_id,
              }),
            });
            const verifyData = await verifyRes.json();
            if (!verifyData.success) {
          
              toast.error("Payment verification failed after payment success.");
            }
            } catch (err) {
              console.error("Error during payment verification:", err);
            }
          },

          modal: {
          ondismiss: async function () {
            try {
              const token = localStorage.getItem("authToken");

              const requestBody = {
                order_id: orderData?.data?.order_id || order_id,
                razorpay_payment_id: `DISMISSED_${orderData?.data?.order_id || order_id}`,
                error_source: "popup_closed",
                error_description: "User dismissed the payment popup",
                error_step: "payment_initiation",
                error_code: "USER_DISMISS",
                error_reason: "User cancelled payment",
              };

              await axios.post(`${api_url}/api/failed-payment`, requestBody, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                },
              });

              toast.error("Payment cancelled");
            } catch (error) {
              console.error("Failed to report dismiss as failed payment:", error);
            }

            setIsProcessing(false);
          },
        },
        
      });

      paymentObject.on("payment.failed", async (response) => {
        console.log("Payment Failed:", response);

        const failedResponse = {
          code: response.error.code,
          description: response.error.description,
          source: response.error.source,
          step: response.error.step,
          reason: response.error.reason,
          metadata: response.error.metadata,
        };

        try {
          const token = localStorage.getItem("authToken");

          const requestBody = {
            order_id: failedResponse.metadata.order_id,
            razorpay_payment_id: failedResponse.metadata.payment_id,
            error_source: failedResponse.source,
            error_description: failedResponse.description,
            error_step: failedResponse.step,
            error_code: failedResponse.code,
            error_reason: failedResponse.reason,
          };

          const res = await axios.post(
            `${api_url}/api/failed-payment`,
            requestBody,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );

          toast.error("Payment Failed Report Sent Added to Vendor!");
          setIsProcessing(false);
        } catch (error) {
          console.error("Payment Failed Report Error:", error);
          setIsProcessing(false);
        }
      });

      paymentObject.open();
    } catch (error) {
      console.error("Payment Error:", error);
      toast.error("An error occurred during payment. Please try again.");
      setIsProcessing(false);
    }
  };

    const handleCODOrder = async () => {
            try {
              setIsCODProcessing(true);
              // 👇 build the same order payload as in onPayment
              const options = {
                products: itemsInCartInCart,
                amount: itemsInCartInCart.reduce(
                  (acc, item) => acc + item.discounted_price * item.quantity,
                  0
                ),
                bill,
                address_id:
                  selectedDeliveryOption === "home" ? selectedAddressId : null,
                branch_id:
                  selectedDeliveryOption === "pickup" ? selectedBranchId : null,
                payment_status: "PENDING",
                payment_type:paymentMode,
                delivery_type:
                  selectedDeliveryOption === "home"
                    ? "Home_Pickup"
                    : "Store_Pickup",
              };

              const res = await fetch(`${api_url}/api/create-order`, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                },
                body: JSON.stringify(options),
              });

              const orderData = await res.json();

              if (!res.ok) {
               const productName = getOutOfStockProductName(orderData?.message);
                if (productName) {
                  toast.error(`${productName} is out of stock.`);
                } else {
                  toast.error(orderData?.message || "Server Error, Please try again later");
                }
                setIsProcessing(false);
                setIsProcessing(false);
                setIsCODProcessing(false);
                setIsCODConfirmPopUp(false)
                return;
              }

              toast.success("Order placed successfully with COD!");
              setCartItemsInCart([]);
              setCartItems([]);
              setCartCount([]);
              setIsCODConfirmPopUp(false);
              setIsProcessing(false);
              setIsCODProcessing(false);
              navigate("/ThankYou");
            } catch (err) {
              console.error("COD Order Error:", err);
              toast.error("Failed to place COD order");
            } finally {
              setIsCODProcessing(false);
            }
    }

  useEffect(() => {
    if (selectedDeliveryOption === "pickup" && !hasFetchedBranches) {
      fetchBranches();
      setHasFetchedBranches(true);
    }

    if (selectedDeliveryOption === "home" && !hasFetchedAddresses) {
      fetchAddresses();
      setHasFetchedAddresses(true);
    }
  }, [selectedDeliveryOption, hasFetchedBranches, hasFetchedAddresses]);

  const fetchBranches = async () => {
    try {
      const response = await axios.get(`${api_url}/branches`);

      const rawBranches = response.data.results || [];

      // ✅ Remove duplicates by branch_id
      const uniqueBranches = [
        ...new Map(
          rawBranches.map((branch) => [branch.branch_id, branch])
        ).values(),
      ];

      setBranches(uniqueBranches);
      console.log("Unique Branches:", uniqueBranches);
    } catch (error) {
      console.error("Error fetching branches:", error);
    }
  };
  const handleClearCart = async() => {
    try{
      const token = localStorage.getItem("authToken");
      const response = await axios.delete(`${api_url}/carts`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        setCartItemsInCart([]);
        setCartItems([]);
        setCartCount(0);
        setShowConfirm(false)
        toast.success("Cart cleared successfully");
      }

    }catch{
      toast.error("Failed to clear cart");
    }
  };
  const scrollLeft = () => {
    scrollRef.current.scrollBy({ left: -200, behavior: "smooth" });
  };

  const scrollRight = () => {
    scrollRef.current.scrollBy({ left: 200, behavior: "smooth" });
  };
  const OutOfQuantityCheck = (variants) => {
    return variants.every((v) => v.quantity === 0);
  };
  return (
    <div className="p-4 max-w-6xl mx-auto   flex-col lg:flex-row overflow-hidden">
      <Helmet>
        <title>
          Shopping Cart | Online Medical Store, Online Medicine Order, Fastest
          Delivery | MediSYS Pharmacy
        </title>
        <meta
          name="description"
          content="MediSYS Pharmacy Online Medical Store - Online Medicine Order - Buy medicines online from MediSYS Pharmacy Store  and experience the fastest home delivery. All kinds of medicines, health products and equipment are available at our online medicine store."
        />
        <meta
          name="keywords"
          content="pharmacy, medical stores, online pharmacy, online pharmacy India, best online pharmacy, online pharmacy hyderabad, online medical store, online medicine store, online medical shop, online medical store hyderabad"
        />
        <meta name="robots" content="index, follow" />
        <meta
          property="og:title"
          content="Online Medical Store, Online Medicine Order, Fastest Delivery | MediSYS Pharmacy"
        />
        <meta
          property="og:description"
          content="MediSYS Pharmacy Online Medical Store - Online Medicine Order - Buy medicines online from MediSYS Pharmacy Store  and experience the fastest home delivery. All kinds of medicines, health products and equipment are available at our online medicine store."
        />
      </Helmet>
      {/* Top Section */}
      <div className="flex justify-between  mb-4 mt-10 ml-5">
        <div className="font-poppins text-[16px] sm:text-xl text-[#1a1a1a] -ml-5 font-semibold">
          <Link to="/home" className="text-black">
            Home
          </Link>
          &nbsp;&gt; My Cart
        </div>
      </div>
      {loading ? (
        <div className="flex justify-center items-center col-span-full">
 <img src={loader} alt="Loading..." className="h-18 w-18 animate-pulse" />
        </div>
      ) : Array.isArray(itemsInCartInCart) && itemsInCartInCart.length > 0 ? (
        <>
          {/* Two Column Container */}
          <div className=" flex flex-col lg:flex-row gap-10 px-4 items-center lg:items-start">
            <div className="flex-row items-center rounded-3xl p-4 lg:w-full max-w-7xl">
              <div className="flex justify-between items-center w-full max-w-7xl mx-auto px-4 mb-2">
                <p className="font-poppins text-[16px] text-[#1a1a1a] font-normal">
                  {itemsInCartInCart.length} item(s) in your cart
                </p>
                <button className="font-poppins text-[16px] text-[#1a1a1a] font-semibold" onClick={() => setShowConfirm(true)}>
                  Clear Cart
                </button>
              </div>

              {itemsInCartInCart.map((item, index) => (
                <div
                  key={`${item.product_id}-${item.variant_id}`}
                  className="relative flex flex-row items-center rounded-3xl border border-[#eaeaea] bg-white mb-4 px-6 py-6 lg:px-4 lg:py-4  justify-between w-[300px] h-[150px] sm:w-[460px] sm:h-[230px] lg:w-full"
                >
                  {/*  */}
                  <div className="flex flex-row">
                    {/*  */}
                    <Link
                      to="#"
                      onClick={(e) => {
                        const productId = item.product_id;
                        const variantId = item.variant_id;
                        e.preventDefault();
                        console.log(
                          "✅ Click Event - Sending Product & Variant ID:",
                          item,
                          { productId, variantId }
                        );
                        handleclickforfeaturedproduct(productId, item);
                      }}
                      className="flex justify-center items-center h-20 sm:h-40 w-20 sm:w-40 -mt-5 -ml-5 sm:ml-0 sm:mt-2"
                    >
                      <img
                        key={item.product_id}
                        src={item?.image}
                        alt={item.name || "Product"}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = "/default.svg";
                        }}
                        // className="sm:w-40 sm:h-40 h-20 w-20 m-2 "
                        className=" max-w-[70px] max-h-[70px] sm:max-w-full sm:max-h-full object-contain"
                      />
                    </Link>

                    {/* */}
                    <div className="flex flex-col md:ml-2 md:-mt-0 lg:mt-6 -mt-2 lg:ml-[15px]">
                      <div className="flex space-x-3 sm:space-x-40 items-center mb-2">
                        <div className="text-[14px] sm:text-base font-medium sm:font-semibold font-poppins flex break-words leading-none sm:leading-tight">
                          <span
                            className="sm:hidden truncate w-[120px] inline-block"
                            title={item.name}
                          >
                            {item.name?.length > 15
                              ? item.name.substring(0, 25) + "..."
                              : item.name}
                          </span>
                          <span className="hidden sm:inline">{item.name}</span>
                        </div>

                        <div
                          className="delete-icon cursor-pointer absolute right-3 top-7 transition duration-200 ease-in-out"
                          onClick={() =>
                            handleDeleteClick(item.product_id, item.variant_id,item)
                          }
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="h-6 w-6 text-gray-500 hover:text-red-600 transition duration-200"
                          >
                            <polyline points="3 6 5 6 21 6"></polyline>
                            <path d="M8 6V4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2v2"></path>
                            <path d="M10 11v6"></path>
                            <path d="M14 11v6"></path>
                            <path d="M4 6h16"></path>
                            <path d="M5 6l1 14c.1 1.1.9 2 2 2h8c1.1 0 1.9-.9 2-2l1-14"></path>
                          </svg>
                        </div>

                        {/* Delete Confirmation Modal */}
                        <DeletePromptForCart
                          showModal={showModal}
                          onDelete={confirmDelete}
                          onCancel={() => setShowModal(false)}
                          data={deleteData}
                        />
                      </div>
                      <div className="text-[0.8rem] sm:text-xs font-inter font-normal text-[#1a1a1a] -mt-1 sm:mt-2 mb-2 leading-none sm:leading-tight">
                        By {item.manufacturer}
                      </div>
                      <div className="text-[0.8rem] sm:text-xs font-inter font-normal text-[#1a1a1a] -mt-1   leading-none sm:leading-tight">
                        {item.pack_size}
                      </div>

                      <div className="md:text-sm font-semibold flex flex-row items-center gap-3 text-[#1A1A1A]  flex-wrap  -ml-[3rem] sm:ml-0">
                        {/* Price Section - Flex */}
                        <div className="flex flex-row items-center gap-2">
                          {item.discounted_price &&
                          item.discounted_price < item.price ? (
                            <div className="text-[0.8rem] md:text-sm text-gray-500 font-inter font-normal">
                              <span className="absolute sm:relative left-4 bottom-7 sm:left-auto sm:bottom-auto text-[0.8rem] md:text-sm text-[#1a1a1a] font-inter font-normal">
                                MRP
                              </span>
                              <span className="absolute sm:relative left-12 bottom-7 sm:left-auto sm:bottom-auto sm:ml-1 line-through">
                                {" "}
                                ₹{(item.price * item.quantity).toFixed(2)}
                              </span>
                            </div>
                          ) : (
                            <div className="text-[0.8rem] md:text-sm text-[#1a1a1a] font-inter font-normal">
                              <span className="absolute sm:relative left-4 bottom-7 sm:left-auto sm:bottom-auto text-[0.8rem] md:text-sm">
                                MRP
                              </span>
                              <span className="absolute sm:relative left-12 bottom-7 sm:left-auto sm:bottom-auto">
                                {" "}
                                ₹{(item.price * item.quantity).toFixed(2)}
                              </span>
                            </div>
                          )}

                          {item.discounted_price &&
                            item.discounted_price < item.price && (
                              <div className="absolute sm:relative left-[6.8rem] bottom-7 sm:left-auto sm:bottom-auto text-[0.8rem] md:text-sm text-[#228200] font-inter font-normal">
                                ₹{item.discounted_price * item.quantity}
                              </div>
                            )}

                          {item.discounted_price &&
                            item.discounted_price < item.price && (
                              <div className="absolute sm:relative left-4 bottom-3 sm:left-auto sm:bottom-auto lg:bottom-2 sm:mt-3 ml-1 sm:ml-3 text-[0.8rem] md:text-sm text-[#162c2a] font-inter font-normal">
                                {item.discount_percent}% Off
                              </div>
                            )}
                        </div>

                        {/* Quantity Button */}
                        <div className="absolute right-2 bottom-3 lg:right-3 md:bottom-5 flex items-center space-x-3 sm:ml-auto mt-2">
                          <button
                            className="px-3 py-1 bg-gray-300 rounded-full"
                            // onClick={(event) => handleDecrease(event, item)}
                            onClick={(event) => handleDecrease(event, item)}
                            type="button"
                          >
                            -
                          </button>
                          <span className="text-[0.6rem] sm:text-[1rem]">
                            {/* {item?.quantity} */}
                            {quantities[item.variant_id] || item.quantity}
                          </span>
                          <button
                            className="px-3 py-1 bg-gray-300 rounded-full"
                            onClick={(event) => handleIncrease(event, item)}
                            type="button"
                          >
                            +
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* second container checkbox */}

            <div className="flex-row items-center  rounded-3xl p-4 w-[300px] sm:w-[460px] lg:w-full">
              <div className="flex flex-col gap-2 w-full border rounded-3xl border-gray-300 bg-white h-auto px-3 py-4 space-y-2">
                {/* Delivery Options */}
                <div className="flex items-center mt-5 ml-6">
                  <input
                    type="radio"
                    id="pickup"
                    name="deliveryOption"
                    value="pickup"
                    checked={selectedDeliveryOption === "pickup"}
                    onChange={() => setSelectedDeliveryOption("pickup")}
                    className="h-6 w-6 rounded border border-gray-800 text-green-800 cursor-pointer"
                  />
                  <label
                    htmlFor="pickup"
                    className="ml-2 font-poppins font-medium text-[16px] leading-6 cursor-pointer"
                  >
                    Pick up from store
                  </label>
                </div>

                <div className="flex items-center mt-5 ml-6">
                  <input
                    type="radio"
                    id="home"
                    name="deliveryOption"
                    value="home"
                    checked={selectedDeliveryOption === "home"}
                    onChange={() => setSelectedDeliveryOption("home")}
                    className="h-6 w-6 rounded border border-gray-800 text-green-800 cursor-pointer"
                  />
                  <label
                    htmlFor="home"
                    className="ml-2 font-poppins font-medium text-[16px] leading-6 cursor-pointer"
                  >
                    Home Delivery
                  </label>
                </div>

                {/* Address or Branch Selection */}
                <div className="bg-[#eaeaea] w-full max-w-[560px] rounded-3xl p-5 overflow-auto h-auto">
                  <p className="font-poppins text-[#1a1a1a68] text-lg font-medium">
                    {selectedDeliveryOption === "pickup"
                      ? "Select Pickup Location"
                      : "Select Delivery Address"}
                  </p>
                  {selectedDeliveryOption === "pickup" ? (
                    branches.length > 0 ? (
                      <div className="space-y-4">
                        {branches.map((branch) => (
                          <div
                            key={branch.branch_id}
                            className="border border-gray-200 rounded-md px-4 py-2 flex flex-col"
                          >
                            <div className="flex items-center justify-between">
                              {/* Radio + Label */}
                              <div className="flex items-center gap-2 sm:gap-3">
                                <input
                                  type="radio"
                                  id={`branch${branch.branch_id}`}
                                  name="branch"
                                  checked={
                                    selectedBranchId === branch.branch_id
                                  }
                                  onChange={() =>
                                    setSelectedBranchId(branch.branch_id)
                                  }
                                  className="h-4 w-4 cursor-pointer"
                                />
                                <label
                                  htmlFor={`branch${branch.branch_id}`}
                                  className="font-poppins text-[#1a1a1a] text-sm sm:text-base font-semibold cursor-pointer"
                                >
                                  {branch.area}
                                </label>
                              </div>

                              {/* Right-aligned View Button */}
                              <button
                                onClick={() =>
                                  handleToggleView(branch.branch_id)
                                }
                                className="ml-auto text-xs sm:text-sm px-3 py-1 border border-blue-500 text-blue-600 rounded hover:bg-blue-50 transition"
                              >
                                {openBranchId === branch.branch_id
                                  ? "Hide"
                                  : "View"}
                              </button>
                            </div>

                            {/* Branch Address (toggle section) */}
                            {openBranchId === branch.branch_id && (
                              <div className="mt-2 text-xs sm:text-sm text-gray-700 font-normal pl-7 w-full break-words">
                                {branch.branch_address}, {branch.pincode}
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    ) : (
                      <p className="text-gray-500 text-sm">
                        No branches available
                      </p>
                    )
                  ) : addresses.length > 0 ? (
                    addresses.map((address) => (
                      <div
                        key={address.address_id}
                        className="flex justify-between items-center gap-2 sm:gap-3 mt-3 w-full"
                      >
                        {/* Left Side: Radio + Address Text */}
                        <div className="flex items-center gap-2 flex-wrap w-full">
                          <input
                            type="radio"
                            id={`address${address.address_id}`}
                            name="address"
                            checked={selectedAddressId === address.address_id}
                            onChange={() => setSelectedAddressId(address.address_id)}
                            className="h-4 w-4 cursor-pointer"
                          />
                          <label
                            htmlFor={`address${address.address_id}`}
                            className={`font-poppins text-[#1a1a1a] text-sm sm:text-base font-normal flex-1 ${
                              selectedDeliveryOption === "pickup"
                                ? "cursor-not-allowed"
                                : "cursor-pointer"
                            }`}
                          >
                            {(() => {
                              const isExpanded = !!expandedAddresses[address.address_id];
                              const hasMore =
                                !!getRemaining(address.address_title) ||
                                !!getRemaining(address.address_line_1) ||
                                !!getRemaining(address.address_line_2);
                              return (
                                <>
                                  <span>
                                    {isExpanded
                                      ? address.address_title || ""
                                      : getPreview(address.address_title)}
                                  </span>
                                  {address.address_line_1 && " - "}
                                  {address.address_line_1 && (
                                    <span>
                                      {isExpanded
                                        ? address.address_line_1
                                        : getPreview(address.address_line_1)}
                                    </span>
                                  )}
                                  {address.address_line_2 && " - "}
                                  {address.address_line_2 && (
                                    <span>
                                      {isExpanded
                                        ? address.address_line_2
                                        : getPreview(address.address_line_2)}
                                    </span>
                                  )}{" "}
                                  - {address.city}, {address.pincode}, {address.state},{" "}
                                  {address.mobile_number}
                                  {hasMore && (
                                    <button
                                      type="button"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        toggleAddressExpand(address.address_id);
                                      }}
                                      className="text-blue-600 underline ml-2"
                                    >
                                      {isExpanded ? "less" : "more"}
                                    </button>
                                  )}
                                </>
                              );
                            })()}
                          </label>
                        </div>

                        <div className="flex items-center justify-end">
                          <img
                            src={editIcon}
                            alt="Edit Icon"
                            width="16"
                            height="16"
                            className="cursor-pointer"
                            onClick={() => handleEditClick(address)}
                          />
                        </div>
                      </div>
                    ))
                  ) : (
                    <p className="text-gray-500 text-sm">
                      No addresses available
                    </p>
                  )}

                  {/* Edit Address Popup */}
                  {isEditPopupOpen && selectedAddress && (
                    <div className="fixed inset-0 z-50 flex items-center justify-center">
                      <div className="relative mt-[100px] lg:mt-[150px] bg-white rounded-2xl shadow-lg z-50 w-[360px] h-[350px] md:w-[600px] lg:h-[400px] md:h-[350px] overflow-hidden">
                        {/* Header */}
                        <div className="bg-[#162c2a] rounded-t-2xl flex items-center justify-center relative h-[76px]">
                          <div className="flex justify-between items-center w-48">
                            <img
                              src={logo}
                              alt="Logo"
                              className="w-[111px] h-[34px] object-contain"
                            />
                          </div>
                          <svg
                            onClick={handleClosePopup} 
                            className="absolute right-4 top-4 cursor-pointer h-3 w-3"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M16.1657 12.0029L23.1361 5.03259C24.288 3.88068 24.288 2.01584 23.1361 0.866875C21.9842 -0.282084 20.1193 -0.282084 18.9704 0.866875L12 7.83723L5.02964 0.863929C3.87774 -0.287976 2.01289 -0.287976 0.863929 0.863929C-0.28503 2.01583 -0.28503 3.88068 0.863929 5.02964L7.83428 12L0.863929 18.9704C-0.287976 20.1223 -0.287976 21.9871 0.863929 23.1361C2.01583 24.285 3.88068 24.285 5.02964 23.1361L12 16.1657L18.9704 23.1361C20.1223 24.288 21.9871 24.288 23.1361 23.1361C24.285 21.9842 24.285 20.1193 23.1361 18.9704L16.1657 12V12.0029Z"
                              fill="white"
                            />
                          </svg>
                        </div>

                        {/* Form */}
                        <div className="h-[calc(100%-76px)] overflow-y-auto p-4">
                          <form className="flex flex-col items-center">
                            <h2 className="text-xl font-semibold mb-4">
                              Edit Address
                            </h2>
                            <div className="w-[300px] sm:w-[328px] md:w-[464px] mt-3 lg:mt-6">
                              <label className="block mb-2 text-black font-poppins font-medium lg:text-xl text-md">
                                Name*
                              </label>
                              <input
                                type="text"
                                name="address_title"
                                value={selectedAddress.address_title || ""}
                                maxLength={25}
                                onChange={handleChange}
                                className="border text-md lg:text-lg border-gray-500 w-full h-10 rounded-lg font-poppins text-gray-500 p-2 mb-2 lg:mb-4"
                              />
                              {addressErrors.address_title && (
                                <p className="text-red-500 text-xs mt-1">
                                  {addressErrors.address_title}
                                </p>
                              )}

                              <div>
                                <label className="block mb-2 text-black font-poppins font-medium">
                                  Address Line 1*
                                </label>
                                <input
                                  type="text"
                                  name="address_line_1"
                                  value={selectedAddress?.address_line_1 || ""}
                                  maxLength={120}
                                  required
                                  onChange={handleChange}
                                  className="border border-gray-500 w-full h-10 rounded-lg font-poppins text-gray-500 p-2"
                                />
                                {addressErrors.address_line_1 && (
                                  <p className="text-red-500 text-xs mt-1">
                                    {addressErrors.address_line_1}
                                  </p>
                                )}
                              </div>

                              {/* Address Line 2 */}
                              <div>
                                <label className="block mb-2 text-black font-poppins font-medium">
                                  Address Line 2
                                </label>
                                <input
                                  type="text"
                                  name="address_line_2"
                                  value={selectedAddress.address_line_2 || ""}
                                  maxLength={20}
                                  onChange={handleChange}
                                  className="border border-gray-500 w-full h-10 rounded-lg font-poppins text-gray-500 p-2"
                                />
                                {addressErrors.address_line_2 && (
                                  <p className="text-red-500 text-xs mt-1">
                                    {addressErrors.address_line_2}
                                  </p>
                                )}
                              </div>

                              <label className="block mb-2 text-black font-poppins font-medium lg:text-xl text-md">
                                Pincode*:
                              </label>
                              <input
                                type="text"
                                name="pincode"
                                value={selectedAddress?.pincode || ""}
                                onChange={handleChange}
                                inputMode="numeric"
                                pattern="[0-9]{6}"
                                maxLength={6}
                                className="border text-md lg:text-lg border-gray-500 w-full h-10 rounded-lg font-poppins text-gray-500 p-2 mb-2 lg:mb-4 "
                              />
                              {addressErrors.pincode && (
                                <p className="text-red-500 text-xs mt-1">
                                  {addressErrors.pincode}
                                </p>
                              )}

                              <label className="block mb-2 text-black font-poppins font-medium lg:text-xl text-md">
                                State*:
                              </label>
                              <select
                                name="state"
                                value={selectedAddress?.state || ""}
                                onChange={handleChange}
                                required
                                className="border text-lg border-gray-500 w-full h-10 rounded-lg font-poppins text-gray-500 p-2 mb-4"
                              >
                                <option value="">Select State</option>
                                {indianStates.map((st) => (
                                  <option key={st} value={st}>
                                    {st}
                                  </option>
                                ))}
                              </select>
                              {addressErrors.state && (
                                <p className="text-red-500 text-xs mt-1">
                                  {addressErrors.state}
                                </p>
                              )}
                              <label className="block mb-2 text-black font-poppins font-medium lg:text-xl text-md">
                                Mobile Number*:
                              </label>
                              <input
                                type="text"
                                name="mobile_number"
                                value={selectedAddress?.mobile_number || ""}
                                onChange={handleChange}
                                inputMode="numeric"
                                pattern="[0-9]{10}"
                                maxLength={10}
                                className="border text-md lg:text-lg border-gray-500 w-full h-10 rounded-lg font-poppins text-gray-500 p-2 mb-2 lg:mb-4"
                              />
                              {addressErrors.mobile_number && (
                                <p className="text-red-500 text-xs mt-1">
                                  {addressErrors.mobile_number}
                                </p>
                              )}
  <div className="mt-4 mb-4">
                        <label className="block text-black font-poppins font-medium text-[16px] mb-2">
                          Set as default address?
                        </label>
                        <div className="flex items-center space-x-4">
                          <label className="inline-flex items-center">
                            <input
                              type="radio"
                              className="form-radio h-4 w-4 text-[#162c2a]"
                              name="is_default"
                              checked={selectedAddress.is_default === true}
                              onChange={() => handleChange({
                                target: {
                                  name: 'is_default',
                                  value: true
                                }
                              })}
                            />
                            <span className="ml-2">Yes</span>
                          </label>
                          <label className="inline-flex items-center">
                            <input
                              type="radio"
                              className="form-radio h-4 w-4 text-[#162c2a]"
                              name="is_default"
                              checked={selectedAddress.is_default === false || selectedAddress.is_default === undefined}
                              onChange={() => handleChange({
                                target: {
                                  name: 'is_default',
                                  value: false
                                }
                              })}
                            />
                            <span className="ml-2">No</span>
                          </label>
                        </div>
                      </div>
                              <div className="flex justify-end mt-2 lg:mt-4">
                                <button
                                  type="button"
                                  className="bg-red-500 text-white px-4 py-2 rounded-md mr-2"
                                  onClick={handleClosePopup}
                                >
                                  Cancel
                                </button>
                                <button
                                  type="button"
                                  onClick={handleUpdateAddress}
                                  disabled={!isEditFormValid}
                                  className="bg-green-500 text-white px-4 py-2 rounded-md disabled:opacity-50 disabled:cursor-not-allowed"
                                >
                                  Save
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Add Delivery Address Button */}
                  <button
                    onClick={togglePopup}
                    className="flex items-center gap-2 mt-4 px-2 sm:px-4 py-2 rounded-xl text-gray-700 font-poppins text-sm sm:text-base font-medium hover:bg-gray-100 cursor-pointer active:scale-95"
                  >
                    <MapPin size={20} className="text-gray-700" />
                    Add Delivery Address
                  </button>
                </div>
              </div>

              {/* bill summery */}

              <div className="flex flex-col w-full  border border-[#eaeaea] p-3 rounded-xl justify-start mt-10 overflow-auto">
                <p className="mt-[30px] ml-[15px] text-[#1a1a1a] font-poppins font-semibold text-[16px] leading-[24px]">
                  Payment Mode
                </p>

                 <div className="flex flex-col gap-3 mt-6 ml-4">
                  <label className="flex items-center gap-2 cursor-pointer">
                    <input
                      type="radio"
                      name="paymentMode"
                      value="COD"
                      checked={paymentMode === "COD"}
                      className="w-4 h-4 text-green-600 focus:ring-green-500"
                      onChange={()=>setPaymentMode("COD")}
                    />
                    <span className="text-black font-poppins text-[15px]">Cash on Delivery (COD)</span>
                  </label>

                  <label className="flex items-center gap-2 cursor-pointer">
                    <input
                      type="radio"
                      name="paymentMode"
                      value="ONLINE"
                      checked={paymentMode === "ONLINE"}
                      className="w-4 h-4 text-green-600 focus:ring-green-500"
                      onChange={()=>setPaymentMode("ONLINE")}
                    />
                    <span className="text-black font-poppins text-[15px]">Online Payment (UPI, NET BANKING, CREDIT/DEBIT CARDS)</span>
                  </label>
                </div>
              </div>
              <div className="flex flex-col w-full  border border-[#eaeaea] p-3 rounded-xl justify-start mt-10 overflow-auto">
                <p className="mt-[30px] ml-[15px] text-[#1a1a1a] font-poppins font-semibold text-[16px] leading-[24px]">
                  Bill Summary
                </p>

                <div className="flex justify-between mt-5 ml-4">
                  <span className="text-[#1a1a1ab3] font-poppins font-normal text-[16px] leading-[24px]">
                    Total Price
                  </span>
                  <span className="text-black font-poppins font-medium text-[16px] leading-[24px]">
                    ₹{originalTotal.toFixed(2)}
                  </span>
                </div>

                <div className="flex justify-between mt-5 ml-4">
                  <span className="text-[#1a1a1ab3] font-poppins font-normal text-[16px] leading-[24px]">
                    Discount on MRP
                  </span>
                  <span className="text-black font-poppins font-medium text-[16px] leading-[24px]">
                    ₹{totalSaved.toFixed(2)}
                  </span>
                </div>

                {/* <div className="flex justify-between mt-5 ml-4">
                  <span className="text-[#1a1a1ab3] font-poppins font-normal text-[16px] leading-[24px]">
                    Subtotal
                  </span>
                  <span className="text-black font-poppins font-medium text-[16px] leading-[24px]">
                    ₹{subtotal.toFixed(2)}
                  </span>
                </div> */}

                <div className="flex justify-between mt-5 ml-4">
                  <span className="text-[#1a1a1ab3] font-poppins font-normal text-[16px] leading-[24px]">
                    Delivery
                  </span>
                  <span className="text-[#228200] font-poppins font-medium text-[16px] leading-[24px]">
                    {shipping}
                  </span>
                </div>

                <div className="flex justify-between mt-5 ml-4">
                  <span className="text-black font-poppins font-semibold text-[16px] leading-[24px]">
                    Total
                  </span>
                  <span className="ml-[35px] text-black font-poppins font-semibold text-[16px] leading-[24px]">
                    ₹{total.toFixed(2)}
                  </span>
                </div>

                <div className="flex justify-between mt-5 ml-4">
                  <span className="text-black font-poppins font-semibold text-[16px] leading-[24px]">
                    Total saved
                  </span>
                  <span className="ml-[35px] text-black font-poppins font-semibold text-[16px] leading-[24px]">
                    ₹{totalSaved.toFixed(2)}
                  </span>
                </div>

                <button
                  className={`w-full h-14 rounded-[20px] bg-[#162c2a] text-white mt-4 flex items-center justify-center gap-2 transition-transform hover:bg-green-600 ${(isProcessing && !addressError) ? 'opacity-70 cursor-not-allowed hover:scale-100' : ''}`}
                  onClick={onPayment}
                  disabled={isProcessing && !addressError}
                >
                  {isProcessing && !addressError && (
                    <span className="animate-spin rounded-full h-6 w-6 border-b-2 border-white mr-2"></span>
                  )}
                  Proceed to Buy
                </button>
              </div>
            </div>
          </div>

          {/* featured section for laptop */}
          <div className="mt-10 lg:block hidden">
            <h1 className="text-black font-poppins font-semibold lg:leading-[30px] lg:text-[20px] text-base -top-5 mb-6">
              Trending Products
            </h1>

            <div className="relative w-full flex flex-col items-center  ">
              {/* Product Container */}
              <div className="overflow-x-auto overflow-y-hidden lg:overflow-hidden w-full flex justify-center">
                <div className="flex gap-5  lg:ml-[0px] ml-[500px]">
                  {Array.isArray(visibleFeatured) &&
                    visibleFeatured.map((item, index) => {
                      const isWishlisted = wishlistItems.some(
                        (w) =>
                          w.product_id === item.product_id &&
                          w.variant_id === item.variant?.[0]?.variant_id
                      );
                      return (
                        <div
                          key={index}
                          className="group flex flex-col items-center justify-center w-[140px] sm:w-[160px] md:w-[200px] h-[200px] sm:h-[220px] md:h-[320px] text-center border border-gray-300 rounded-lg overflow-hidden bg-white transition-transform duration-300 transform hover:scale-105 shadow-md"
                          style={{
                            border: "0.74px solid #eaeaea",
                            borderRadius: "10px",
                          }}
                        >
                          <Link
                            to="#"
                            onClick={(e) => {
                              e.preventDefault();
                              handleclickforfeaturedproduct(
                                item.product_id,
                                item
                              );
                            }}
                            className="flex flex-col items-center justify-center w-full h-full px-2 pt-2 pb-1"
                          >
                            <div
                              className="absolute top-2 left-2 z-20"
                              onMouseEnter={() => setTooltipOpen(index)}
                              onMouseLeave={() => setTooltipOpen(null)}
                            >
                              <button
                                className="focus:outline-none"
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  const isToken =
                                    localStorage.getItem("authToken");
                                  if (!isToken) {
                                    setShowLoginPopup(true);
                                    return;
                                  }
                                  if (isWishlisted) {
                                    removeFromWishlist(
                                      item.product_id,
                                      item.variant?.[0]?.variant_id
                                    );
                                  } else {
                                    addToWishlist(item, item.variant?.[0]);
                                  }
                                }}
                                disabled={wishlistLoading}
                              >
                                <img
                                  src={isWishlisted ? wish : wishlist}
                                  alt={
                                    isWishlisted
                                      ? "Remove from wishlist"
                                      : "Add to wishlist"
                                  }
                                  className="w-5 h-5 lg:w-6 lg:h-6 transition-all"
                                />
                              </button>
                              {/* Tooltip */}
                              <div
                                className={`absolute left-7 top-1 px-2 py-1 rounded bg-black text-white text-xs whitespace-nowrap shadow transition-opacity duration-200 ${
                                  tooltipOpen === index
                                    ? "opacity-100 visible"
                                    : "opacity-0 invisible"
                                } z-30`}
                              >
                                {isWishlisted
                                  ? "Remove from wishlist"
                                  : "Add to wishlist"}
                              </div>
                            </div>
                            {/* Product Image */}
                            <div className="relative w-full flex justify-center">
                              <img
                                src={
                                  item?.product_images?.image_url
                                    ?.primary_image ||
                                  "https://via.placeholder.com/150"
                                }
                                alt={item.name || "Product Image"}
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = "/default.svg";
                                }}
                                className="w-[100px] h-[100px] sm:w-[140px] sm:h-[140px] md:w-[120px] md:h-[140px] rounded-lg "
                              />
                              {item.discount_percent > 0 && (
                                <div className="absolute top-1 md:-top-1 right-3 bg-red-500 text-white text-xs font-semibold w-9 h-9 flex items-center justify-center rounded-full z-20">
                                  {item.discount_percent}% OFF
                                </div>
                              )}
                            </div>

                            {/* Product Details */}
                            <div className="w-full text-center mt-2">
                              <div className="text-sm font-semibold text-gray-900 truncate w-full font-poppins">
                                {item.name || "No Name"}
                              </div>
                              <div className="text-sm font-semibold font-inter flex gap-3 text-[#1A1A1A] justify-center">
                                {item.discount_percent > 0 && (
                                  <div className="text-sm text-gray-500 line-through">
                                    ₹{item.variant[0]?.price}
                                  </div>
                                )}
                                <div>₹{item.variant[0]?.discounted_price}</div>
                              </div>
                            </div>
                            <div className="h-5">
                              {OutOfQuantityCheck(item.variant) && (
                                <div>
                                  <p className="text-xs text-red-500 font-semibold">
                                    Out of Stock
                                  </p>
                                </div>
                              )}
                            </div>
                          </Link>

                          {/* Cart Actions (OUTSIDE Link) */}
                          <div className="w-full px-2 pb-2">
                            {Array.isArray(item.variant) && item.variant.length > 1 ? (
                              <button
                                className="bg-[#162c2a] hover:bg-green-600 disabled:hover-none disabled:bg-gray-500 text-[11px] font-[300] md:text-[12px] md:font-[300] lg:text-[16px] lg:font-[500] font-poppins sm:text-base w-full h-10 text-white rounded-md transition-all flex items-center justify-center gap-2"
                                onClick={(event) => {
                                  event.preventDefault();
                                  event.stopPropagation();
                                  const isToken = localStorage.getItem('authToken');
                                  if (!isToken) {
                                    setShowLoginPopup(true);
                                    return;
                                  }
                                  handleclickforfeaturedproduct(item.product_id, item);
                                }}
                                type="button"
                                disabled={OutOfQuantityCheck(item.variant)}
                              >
                                <img src={addToCartIcon} alt="Cart" className="w-[14px] h-[14px] lg:w-[15px] lg:h-[18px] font-500 lg:mr-3 object-contain" />
                                Add to Cart
                              </button>
                            ) : getCartQuantity(item.variant[0]?.variant_id) > 0 ? (
                              <div className="flex items-center justify-between border-2 border-black rounded-xl lg:px-4 gap-2 sm:gap-5 w-full mx-auto">
                                <button
                                  className="px-2 sm:px-3 py-1 text-lg sm:text-xl text-black cursor-pointer"
                                  onClick={(event) =>
                                    handleDecreaseForTrendingProduct(
                                      event,
                                      item.variant[0],
                                      item
                                    )
                                  }
                                  type="button"
                                >
                                  -
                                </button>
                                <span className="text-base sm:text-lg font-bold text-black min-w-[20px] text-center">
                                  {getCartQuantity(item.variant[0]?.variant_id)}
                                </span>
                                <button
                                  className="px-2 sm:px-3 py-1 text-lg sm:text-xl text-black cursor-pointer"
                                  onClick={(event) =>
                                    handleIncreaseForTrendingProduct(
                                      event,
                                      item.variant[0],
                                      item
                                    )
                                  }
                                  type="button"
                                >
                                  +
                                </button>
                              </div>
                            ) : (
                              <button
                                className="bg-[#162c2a] hover:bg-green-600 disabled:hover-none disabled:bg-gray-500 text-[11px] font-[300] md:text-[12px] md:font-[300] lg:text-[16px] lg:font-[500] font-poppins sm:text-base w-full h-10 text-white  rounded-md  transition-all flex items-center justify-center gap-2"
                                onClick={async (event) => {
                                  event.preventDefault();
                                  event.stopPropagation();
                                  await handleAddToCart(
                                    item,
                                    item.variant[0],
                                    1
                                  );
                                  await fetchCart();
                                }}
                                disabled={OutOfQuantityCheck(item.variant)}
                              >
                                <img
                                  src={addToCartIcon}
                                  alt="Cart"
                                  className="w-[14px] h-[14px] lg:w-[15px] lg:h-[18px] font-500 lg:mr-3 object-contain"
                                />
                                Add to Cart
                              </button>
                            )}
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>

              <div
                className="invisible lg:visible absolute top-1/2 transform -translate-y-1/2 z-10 lg:left-[-15px]"
                onClick={prevFeatured}
              >
                <button className="bg-white border border-gray-300 shadow-md rounded-full w-10 h-10 flex items-center justify-center transition-all duration-200 hover:bg-[#162C2A] hover:scale-110 hover:shadow-xl group">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5 text-gray-700 group-hover:text-white transition-colors duration-200"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15 19l-7-7 7-7"
                    />
                  </svg>
                </button>
              </div>

              {/* Right Arrow */}
              <div
                className="invisible lg:visible absolute top-1/2 transform -translate-y-1/2 z-10 lg:right-[-15px]"
                onClick={nextFeatured}
              >
                <button className="bg-white border border-gray-300 shadow-md rounded-full w-10 h-10 flex items-center justify-center transition-all duration-200 hover:bg-[#162C2A] hover:scale-110 hover:shadow-xl group">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5 text-gray-700 group-hover:text-white transition-colors duration-200"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </button>
              </div>
            </div>

            <div className="md:flex items-center justify-center -mt-[20px]">
              <Link to={"/featured-products"}>
                <button className="mt-[2.3rem] ml-16 lg:mt-[60px] bg-[#162C2A] hover:bg-green-600 text-white rounded-[5px] py-2 px-4 cursor-pointer font-poppins">
                  View All
                </button>
              </Link>
            </div>

            {isPopupOpen && (
              <Adresspopup
                onClose={() => setPopupOpen(false)}
                fetchAddresses={fetchAddresses}
              />
            )}
          </div>

          {/* featured section for mobile screens */}
          <div className="mt-10 block lg:hidden px-4">
            <h1 className="text-black font-poppins font-semibold text-base mb-2">
              Trending Products
            </h1>

            <div className="relative">
              <button
                className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-md p-2 rounded-full"
                onClick={scrollLeft}
              >
                <ChevronLeft size={20} />
              </button>

              <div
                ref={scrollRef}
                className="flex overflow-x-auto scroll-smooth gap-4 no-scrollbar px-8"
              >
                {loading && (
            <img src={loader} alt="Loading..." className="h-10 w-10 animate-pulse" />
                )}

                {Array.isArray(visibleFeatured) &&
                  visibleFeatured.map((item, index) => (
                    <div
                      key={index}
                      className="group flex-shrink-0 flex flex-col items-center justify-between w-[150px] h-auto text-center border border-gray-300 rounded-lg overflow-hidden bg-white transition-transform duration-300 hover:scale-105 shadow-md"
                      style={{
                        border: "0.74px solid #eaeaea",
                        borderRadius: "10px",
                      }}
                    >
                      {/* Product Image and Link */}
                      <Link
                        to="#"
                        onClick={(e) => {
                          e.preventDefault();
                          handleclickforfeaturedproduct(item.product_id, item);
                        }}
                        className="w-full flex flex-col items-center"
                      >
                        <div className="relative w-full flex justify-center pt-3">
                          <img
                            src={
                              item?.product_images?.image_url?.primary_image ||
                              "https://via.placeholder.com/150"
                            }
                            alt={item.name || "Product Image"}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = "/default.svg";
                            }}
                            className="w-[100px] h-[100px] rounded-lg"
                          />
                          {item.discount_percent > 0 && (
                            <div className="absolute -top-1 right-2 bg-red-500 text-white text-xs font-semibold w-9 h-9 flex items-center justify-center rounded-full z-20">
                              {item.discount_percent}% OFF
                            </div>
                          )}
                        </div>

                        <div className="w-full text-center mt-2 px-2 pb-3">
                          <div className="text-sm font-semibold text-gray-900 truncate w-full">
                            {item.name || "No Name"}
                          </div>

                          <div className="text-xs font-semibold flex gap-2 text-[#1A1A1A] justify-center mt-1">
                            {item.discount_percent > 0 && (
                              <div className="text-xs text-gray-500 line-through">
                                ₹{item.variant[0]?.price}
                              </div>
                            )}
                            <div>₹{item.variant[0]?.discounted_price}</div>
                          </div>
                          <div className="h-5">
                            {OutOfQuantityCheck(item.variant) && (
                              <div>
                                <p className="text-xs text-red-500 font-semibold">
                                  Out of Stock
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </Link>

                      {/* Add to Cart or Quantity Control - OUTSIDE LINK */}
                      <div className="w-full px-2 pb-2">
                        {Array.isArray(item.variant) && item.variant.length > 1 ? (
                          <button
                            className="bg-[#162c2a] hover:bg-green-600 disabled:hover-none disabled:bg-gray-500 text-[11px] font-[300] md:text-[12px] md:font-[300] lg:text-[16px] lg:font-[500] font-poppins sm:text-base w-full h-10 text-white rounded-md transition-all flex items-center justify-center gap-2"
                            onClick={(event) => {
                              event.preventDefault();
                              event.stopPropagation();
                              const isToken = localStorage.getItem('authToken');
                              if (!isToken) {
                                setShowLoginPopup(true);
                                return;
                              }
                              handleclickforfeaturedproduct(item.product_id, item);
                            }}
                            type="button"
                            disabled={OutOfQuantityCheck(item.variant)}
                          >
                            <img src={addToCartIcon} alt="Cart" className="w-[14px] h-[14px] lg:w-[15px] lg:h-[18px] font-500 lg:mr-3 object-contain" />
                            Add to Cart
                          </button>
                        ) : getCartQuantity(item.variant[0]?.variant_id) > 0 ? (
                          <div className="flex items-center justify-between border-2 border-black rounded-xl lg:px-4 gap-2 sm:gap-5 w-full mx-auto">
                            <button
                              className="px-2 sm:px-3 py-1 text-lg sm:text-xl text-black cursor-pointer"
                              onClick={(event) =>
                                handleDecreaseForTrendingProduct(
                                  event,
                                  item.variant[0],
                                  item
                                )
                              }
                              type="button"
                            >
                              -
                            </button>
                            <span className="text-base sm:text-lg font-bold text-black min-w-[20px] text-center">
                              {getCartQuantity(item.variant[0]?.variant_id)}
                            </span>
                            <button
                              className="px-2 sm:px-3 py-1 text-lg sm:text-xl text-black cursor-pointer"
                              onClick={(event) =>
                                handleIncreaseForTrendingProduct(
                                  event,
                                  item.variant[0],
                                  item
                                )
                              }
                              type="button"
                            >
                              +
                            </button>
                          </div>
                        ) : (
                          <button
                            className="bg-[#162c2a] hover:bg-green-600  disabled:hover-none disabled:bg-gray-500 text-[11px] font-[300] md:text-[12px] md:font-[300] lg:text-[16px] lg:font-[500] font-poppins sm:text-base w-full h-10 text-white  rounded-md transition-all flex items-center justify-center gap-2"
                            onClick={async (event) => {
                              event.preventDefault();
                              event.stopPropagation();
                              await handleAddToCart(item, item.variant[0], 1);
                              await fetchCart();
                            }}
                            disabled={OutOfQuantityCheck(item.variant)}
                          >
                            <img
                              src={addToCartIcon}
                              alt="Cart"
                              className="w-[14px] h-[14px] lg:w-[15px] lg:h-[18px] font-500 lg:mr-3 object-contain"
                            />
                            Add to Cart
                          </button>
                        )}
                      </div>
                    </div>
                  ))}
              </div>

              {/* Right Arrow */}
              <button
                className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-md p-2 rounded-full"
                onClick={scrollRight}
              >
                <ChevronRight size={20} />
              </button>
            </div>

            {/* View All Button */}
            <div className="text-center mt-4">
              <Link to="/featured-products">
                <button className="bg-[#162C2A] hover:bg-green-600 text-white rounded-[10px] py-2 px-5 cursor-pointer font-poppins text-sm">
                  View All
                </button>
              </Link>
            </div>
          </div>
        </>
      ) : (
        <div className="flex  flex-col justify-center items-center h-[450px]">
          <div className="flex justify-center items-center">
            <DotLottieReact
              src="https://lottie.host/66e677d4-91a1-4f1a-85e7-a7d1faf607b8/dBHVRTKEJU.lottie"
              loop
              autoplay
            />
          </div>
          <h3 className="font-poppins text-2xl text-[#848484]">
            Look like you have not added anything to cart.
          </h3>
          <h3 className="font-poppins text-2xl text-[#848484]">
            Go ahead and add product to shop
          </h3>
          <Link to="/home">
            <button className="px-6 py-2 bg-[#162c2a] hover:bg-green-600 text-white rounded-2xl flex items-center gap-2  transition mt-4">
              Start Shopping
    
            </button>
          </Link>
        </div>
      )}
      {showConfirm && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/40 z-50">
          <div className="bg-white rounded-xl p-6 shadow-lg w-[300px] text-center">
            <h2 className="text-lg font-semibold mb-4">Are you sure?</h2>
            <p className="text-sm text-gray-600 mb-6">
              This will remove all items from your cart.
            </p>
            <div className="flex justify-between">
              <button
                className="px-4 py-2 bg-gray-300 rounded-md"
                onClick={() => setShowConfirm(false)}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600"
                onClick={handleClearCart}
              >
                Yes, Clear
              </button>
            </div>
          </div>
        </div>
      )}

     {isCODConfirmPopUp && 
     <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
        <div className="bg-white rounded-2xl shadow-lg p-6 w-96">
          <h2 className="text-lg font-semibold text-black mb-4">
            Confirm COD Order
          </h2>
          <p className="text-gray-600 mb-6">
            Are you sure you want to place this order with{" "}
            <span className="font-bold text-black">Cash on Delivery</span>?
          </p>

          <div className="flex justify-end gap-3">
            <button
              onClick={()=>{
                setIsCODConfirmPopUp(false);
                setIsProcessing(false);
         
              }}
              className={`px-4 py-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100 ${isCODProcessing ? 'opacity-50 cursor-not-allowed hover:bg-transparent' : ''}`}
              disabled={isCODProcessing}
            >
              Cancel
            </button>
            <button
              onClick={handleCODOrder}
              disabled={isCODProcessing}
              className={`px-4 py-2 rounded-lg bg-green-600 text-white hover:bg-green-700 flex items-center ${isCODProcessing ? 'opacity-70 cursor-not-allowed' : ''}`}
            >
              {isCODProcessing && (
                <span className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></span>
              )}
              Confirm
            </button>
          </div>
        </div>
      </div>
      }

    </div>
  );
};

export default Cartpage;
